import axios from 'axios';

import appSettings from '../app-settings';

const API_URL = `${appSettings.baseUrl}/accounts/users/invites`;

// Authenticated (tenant administrator) routes.

export const getUserInvites = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

/** Create an invite. Returns the AdminUserInvite (includes `inviteUrl` and `expiresAt`). */
export const createUserInvite = async ({ email, role, firstName, lastName }) => {
  const response = await axios.post(API_URL, { email, role, firstName, lastName });
  return response.data;
};

/** Re-send the invite email and reset its expiry. Returns the refreshed AdminUserInvite. */
export const resendUserInvite = async (inviteId) => {
  const response = await axios.post(`${API_URL}/${encodeURIComponent(inviteId)}/resend`);
  return response.data;
};

export const revokeUserInvite = async (inviteId) => {
  await axios.delete(`${API_URL}/${encodeURIComponent(inviteId)}`);
};

// Public (unauthenticated) routes used by the accept-invite page.

export const getPublicUserInvite = async (inviteId) => {
  const response = await axios.get(`${API_URL}/${encodeURIComponent(inviteId)}/public`);
  return response.data;
};

/** Accept an invite. The email always comes from the invite record server-side. Returns `{ email }`. */
export const acceptUserInvite = async (inviteId, { password, firstName, lastName }) => {
  const response = await axios.post(`${API_URL}/${encodeURIComponent(inviteId)}/accept`, {
    password,
    firstName,
    lastName,
  });
  return response.data;
};
